import { render, staticRenderFns } from "./comm-menu.vue?vue&type=template&id=22c199a0&scoped=true&"
import script from "./comm-menu.vue?vue&type=script&lang=js&"
export * from "./comm-menu.vue?vue&type=script&lang=js&"
import style0 from "./comm-menu.vue?vue&type=style&index=0&id=22c199a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c199a0",
  null
  
)

export default component.exports